export default __webpack_public_path__ + "static/customerSupport-9c56f474fd20ec2257da924332e8fa08.png";